import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile } from "@ffmpeg/util";

const ffmpeg = new FFmpeg();

let isLoaded = false;

export async function convertAudio(file, options = {}) {
  if (!file) return null;

  const {
    outputFormat = "mp3",
    bitrate = "128k",
  } = options;

  // 初回ロード
  if (!isLoaded) {
    await ffmpeg.load();
    isLoaded = true;
  }

  const inputName = `input.${file.name.split(".").pop()}`;
  const outputName = `output.${outputFormat}`;

  // 書き込み
  await ffmpeg.writeFile(inputName, await fetchFile(file));

  // 実行
  await ffmpeg.exec([
    "-i", inputName,
    "-b:a", bitrate,
    outputName
  ]);

  // 読み込み
  const data = await ffmpeg.readFile(outputName);

  const blob = new Blob([data.buffer], {
    type: `audio/${outputFormat}`,
  });

  return {
    url: URL.createObjectURL(blob),
    blob,
  };
}